// 配置路由文件

import { QuestionCircleOutlined, DownloadOutlined, UserOutlined, AppstoreOutlined, FileDoneOutlined, MoneyCollectOutlined, FundViewOutlined, PlusSquareOutlined, AccountBookOutlined, SettingOutlined, SmileOutlined, GiftOutlined, TagsOutlined, SolutionOutlined, MonitorOutlined, CarryOutOutlined, TeamOutlined, GlobalOutlined, BarChartOutlined } from '@ant-design/icons';

// eslint-disable-next-line import/no-anonymous-default-export
export default [
  {
    title: '商家管理',
    route: '/manager_client',
    icon: <TeamOutlined />,
    role: ['管理员'],
  },
  {
    title: '提货码管理',
    route: '/activity',
    icon: <GiftOutlined />,
    role: ['管理员'],
  },
  // {
  //   title: '报名表管理',
  //   route: '/form',
  //   icon: <AppstoreOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '首页文章',
  //   route: '/news',
  //   icon: <FileDoneOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '意见反馈',
  //   route: '/suggestion',
  //   icon: <QuestionCircleOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '管理员管理',
  //   route: '/admin_user',
  //   icon: <UserOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '费用设定',
  //   route: '/admin_basic_info/price_setting',
  //   icon: <SettingOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '下载中心',
  //   route: '/download_center',
  //   icon: <DownloadOutlined />,
  //   role: ['管理员'],
  // },
  // {
  //   title: '报名表下载',
  //   route: '/form_data',
  //   icon: <DownloadOutlined />,
  //   hidden: true,
  //   para: 'id',
  // },
]


